// src/app/gonderiYorumUrl.ts
//
// ─── GÖNDERİ YORUM PANELİ → ADRES ÇUBUĞU (saf şema katmanı) ──────────────────
//
// ── ÖLÇÜLEN BOŞLUK ──────────────────────────────────────────────────────────
// Mobil `CommentsPanel` (`ProfilePostViewerMobile` üstünde açılan sheet)
// açıldığında adres `/p/{id}`de KALIYORDU: panelin kendi adresi YOK, soğuk
// yükü YOK. `klipYorumUrl.ts`in ikizi, farklı yüzeyde.
//
// ── NİYE ÖNCEKİ TUR "HAYIR" DEDİ VE NİYE BU TUR "EVET" ──────────────────────
// Önceki tur (`gonderiYorumKanonik.test.ts` K6) bunu ÖLÇEREK reddetti ve
// gerekçesi sağlamdı: router'ın tanıdığı tek gönderi-yorum şekli
// `/p/{id}/c/{cid}` (yorum kimliği ZORUNLU); panel ise ÇAPASIZ açılır.
// `/p/{id}/comments` yazmak, soğuk yüklemede karşılığı OLMAYAN bir adres
// yazmak olurdu → **yalan söyleyen adres**.
//
// Bu tur o gerekçe çürütülmedi, ORTADAN KALDIRILDI: adres yazılmadan ÖNCE
// o adresi çözen halkalar kuruldu. Sıra bilerek "önce cold-load, sonra adres".
//
// ── ÖLÇÜLEN COLD-LOAD ZİNCİRİ (üç halka, ÜÇÜ DE gerekliydi) ─────────────────
// `firebase.json`: `/p/**` → **`renderPostShare` Cloud Function**'ına gider,
// `index.html`e DEĞİL. Yani SPA matcher'ı tek başına soğuk yükü VERMEZ —
// bu, matcher yazmadan önce ölçüldü ve tasarımı değiştirdi:
//
//   1. `functions/src/post_og.ts` — yolu okur, insanı `/?p={id}`ye yollar.
//      `/comments` eki burada DÜŞÜYORDU → `&yorumlar=1` ile taşınır.
//   2. `appRouting.ts` `?p=` kolu — `yorumlar=1` okunur, `yorumOdak` geçilir
//      ve adres `gercekYol` olarak `/p/{id}/comments` yeniden kurulur.
//   3. `appRouting.ts` yol matcher'ı — uygulama-içi popstate/gezinme.
//
// ⚠️ 1. halka bir **Cloud Function**tır ve bu depoda functions OTOMATİK DEPLOY
//    EDİLMEZ (CLAUDE.md: "hosting otomatik, rules/functions elle"). Deploy
//    edilene kadar `/p/{id}/comments` soğuk yükü `/p/{id}`ye normalize olur:
//    gönderi ve YORUM LİSTESİ yine gelir (kanonik modal yorumları satır-içi
//    render eder), yalnız odak/adres inceliği kaybolur. Bu bir yalan değil,
//    ölçülmüş ve belgelenmiş bir DEĞER KAYBI — `/c/{id}/edit` soğuk-yük
//    normalizasyonunun aynı sınıfı ("sheet geri getirilemiyorsa içeriği
//    getir ve adresin artık açık olmayan bir şeyi iddia etmesini bırak").
//
// ── NİYE YALNIZ GÖNDERİ, KLİP DEĞİL (ölçüldü, varsayılmadı) ─────────────────
// Panel klip öğelerine de açılıyor (`yorumHedefi` → `targetType:"clip"`).
// Ama `/c/{id}` soğuk yükü ÖLÇÜLDÜ: `mClip` kolu `toFeed:false` ile
// `openClipFromUrl`e gider ve `viewingClip` katmanını açar; o katmanın
// bileşenleri (`ClipDetailModalMobile`/`Desktop`) HİÇBİR yorum yüzeyi
// içermez (ikisinde de `CommentSheetV3`/`EngagementRailV3` atfı 0).
// Yani `/c/{id}/comments` yazmak, soğuk yüklemede yorum AÇMAYAN bir adres
// yazmak olurdu — tam olarak bu turun ortadan kaldırdığı kusur. Klip kolu
// bu yüzden ADRESSİZ kalır; gerekçe artık varsayım değil ölçüm.
//
// SAF: import yok, DOM yok, I/O yok → kapı gerçek fonksiyonu koşturur.

/**
 * Panel adresinin eki. TEK YERDE — `functions/src/post_og.ts` bu dizgeyi
 * kendi (ayrı paket) kopyasında taşır ve `gonderiYorumZinciri.test.ts`
 * ikisinin ayrışmadığını AST/kaynak taramasıyla ölçer.
 */
export const GONDERI_YORUM_EKI = "comments";

/** Soğuk-yük redirect'inde niyeti taşıyan sorgu anahtarı (`/?p={id}&yorumlar=1`). */
export const GONDERI_YORUM_SORGUSU = "yorumlar";

/** `appRouting.mPost` ile AYNI kimlik sınıfı — ikinci bir "id nedir" tanımı YOK. */
const KIMLIK = /^[A-Za-z0-9_-]+$/;

const temiz = (v?: string | null): string => (typeof v === "string" ? v.trim() : "");

/** Gönderinin taban yolu (`/p/{id}`). Geçersiz id → `null`. */
export function gonderiTabanYolu(postId?: string | null): string | null {
  const id = temiz(postId);
  if (!id || !KIMLIK.test(id)) return null;
  return `/p/${id}`;
}

/**
 * Yorum paneli yolu: `/p/{id}/comments`.
 *
 * Çapa (commentId) GEREKMEZ — bu şeklin varlık sebebi zaten ÇAPASIZ açılıştır.
 * Çapalı permalink ayrı ve DEĞİŞMEDİ: `/p/{id}/c/{cid}[/r/{rid}]`.
 */
export function gonderiYorumPaneliYolu(postId?: string | null): string | null {
  const taban = gonderiTabanYolu(postId);
  return taban ? `${taban}/${GONDERI_YORUM_EKI}` : null;
}

/** Verilen yol bir gönderi yorum PANELİ yolu mu? */
export function gonderiYorumPaneliYolundaMi(yol?: string | null): boolean {
  return yoldanGonderiYorumPaneli(yol) !== null;
}

/**
 * Yoldan gönderi kimliğini çıkarır (`/p/{id}/comments` → `id`), değilse `null`.
 *
 * Router bu fonksiyonu ÇAĞIRIR; regex `appRouting.ts`e KOPYALANMAZ
 * (`yoldanBilgi`/`yoldanKoleksiyon` ile aynı tek-kaynak deseni).
 *
 * ⚠️ Sorgu/parça ATILIR: `resolvePathToPage`e `location.pathname` gelir ama
 * yüklem `mevcut = pathname + search` ile de çağrılıyor (kanca katmanı).
 * İkisi ayrışırsa soğuk-yük tespiti sessizce yanlış tarafa düşerdi.
 */
export function yoldanGonderiYorumPaneli(yol?: string | null): string | null {
  const ham = temiz(yol).split("?")[0].split("#")[0];
  const m = ham.match(
    new RegExp(`^/p/([A-Za-z0-9_-]+)/${GONDERI_YORUM_EKI}/?$`),
  );
  return m ? m[1] : null;
}
